module.exports = function getResource(label, vars = []) {
    let resources = {
        standard: 'Standard'
    };
    return resources[label];
};
